import React, { useState, useEffect, useContext, useMemo } from 'react';
import axiosInstance from '../axiosConfig';
import { AuthContext } from '../AuthContext';
import Logo from "../assets/Img/Logo-1.png";
import UserImg from "../assets/Img/User.gif";
import DataTable from 'react-data-table-component';
import Swal from 'sweetalert2';

export default function WorkerSalaryView() {
  const { user, logout } = useContext(AuthContext);
  const employeeId = user?.EmployeeID || '';
  
  const [salaryHistory, setSalaryHistory] = useState([]);
  const [advanceHistory, setAdvanceHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  
  const [tableYearFilter, setTableYearFilter] = useState(new Date().getFullYear().toString());

  async function fetchSalaryHistory(showLoader = true) {
    try {
      if (showLoader) setLoading(true);
      const res = await axiosInstance.get(`/api/worker-salary/worker/${employeeId}`);
      setSalaryHistory(res.data);
    } catch (err) {
      console.error(err);
      if (showLoader) Swal.fire('Error', 'Could not load salary history', 'error');
    } finally {
      if (showLoader) setLoading(false);
    }
  }

  useEffect(() => {
    if (!employeeId) return;
    axiosInstance.get(`/api/worker-salary/worker/${employeeId}/advances?month=${selectedMonth}&year=${selectedYear}`)
      .then(res => setAdvanceHistory(res.data || []))
      .catch(() => setAdvanceHistory([]));
  }, [employeeId, selectedMonth, selectedYear]);

  useEffect(() => {
    if (!employeeId) return undefined;

    fetchSalaryHistory();
    const refreshInterval = window.setInterval(() => fetchSalaryHistory(false), 15000);
    const refreshOnFocus = () => fetchSalaryHistory(false);
    window.addEventListener('focus', refreshOnFocus);

    return () => {
      window.clearInterval(refreshInterval);
      window.removeEventListener('focus', refreshOnFocus);
    };
  }, [employeeId]);

  const selectedSalary = useMemo(() => {
    return salaryHistory.find(s => parseInt(s.Month) === selectedMonth && parseInt(s.Year) === selectedYear);
  }, [salaryHistory, selectedMonth, selectedYear]);

  const columns = [
    { name: 'Month/Year', selector: row => `${row.Month}/${row.Year}`, sortable: true },
    { name: 'Total Earned', selector: row => `₹${parseFloat(row.TotalEarned).toFixed(2)}`, sortable: true },
    { name: 'Present Days', selector: row => row.PresentDays, sortable: true },
    { name: 'Advances', selector: row => `₹${parseFloat(row.AdvancesDeducted).toFixed(2)}`, sortable: true },
    { name: 'Penalties', selector: row => `₹${parseFloat(row.Penalties).toFixed(2)}`, sortable: true },
    { 
      name: 'Net Payable', 
      selector: row => parseFloat(row.NetPayable).toFixed(2), 
      sortable: true,
      cell: row => <span className="fw-bold text-success">₹{parseFloat(row.NetPayable).toFixed(2)}</span>
    },
    { 
      name: 'Advance payment', 
      cell: row => (
        <span
          className={`badge rounded-pill px-3 py-1 ${
            row.PaymentStatus === 'Paid'
              ? 'bg-success bg-opacity-10 text-success border border-success border-opacity-25'
              : 'bg-warning bg-opacity-10 text-warning border border-warning border-opacity-25'
          }`}
        >
          <i className={`bi ${row.PaymentStatus === 'Paid' ? 'bi-check-circle-fill' : 'bi-clock-fill'} me-1`}></i> 
          {row.PaymentStatus === 'Paid' ? 'Paid' : 'Pending'}
        </span>
      ), 
      sortable: true 
    },
    {
      name: 'Salary payment',
      cell: () => (
        <span className="badge rounded-pill px-3 py-1 bg-secondary bg-opacity-10 text-secondary border border-secondary border-opacity-25">
          <i className="bi bi-clock me-1"></i> Pending confirmation
        </span>
      )
    }
  ];

  return (
    <div style={{ backgroundColor: "#f1f5f9", minHeight: "100vh", fontFamily: "'Inter', sans-serif" }}>
      {/* Navbar */}
      <nav
        className="navbar navbar-expand-lg bg-white"
        style={{ boxShadow: "0 1px 5px rgba(0, 0, 0, 0.2)", position: "sticky", top: 0, zIndex: 1000 }}
      >
        <div className="container-fluid">
          <a className="navbar-brand" href="/User-dashboard">
            <img
              src={Logo}
              className="img-fluid rounded-top"
              alt="Logo"
              style={{ height: "40px", marginLeft: "10px" }}
            />
          </a>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
              <li className="nav-item" style={{ marginLeft: "10px" }}>
                <a
                  className="nav-link active"
                  aria-current="page"
                  href="/User-Tickets"
                  style={{ fontWeight: "600", color: "#1e293b", fontSize: "14px", letterSpacing: "0.5px", padding: "8px 16px", borderRadius: "8px", transition: "all 0.2s" }}
                  onMouseOver={(e) => { e.target.style.color = "#ff0000"; e.target.style.transform = "translateY(-1px)"; }}
                  onMouseOut={(e) => { e.target.style.color = "#1e293b"; e.target.style.transform = "translateY(0)"; }}
                >
                  <i className="bi bi-ticket-detailed me-1"></i> TICKET
                </a>
              </li>
              <li className="nav-item" style={{ marginLeft: "10px" }}>
                <a
                  className="nav-link active"
                  aria-current="page"
                  href="/wip-worker-app"
                  style={{ fontWeight: "600", color: "#1e293b", fontSize: "14px", letterSpacing: "0.5px", padding: "8px 16px", borderRadius: "8px", transition: "all 0.2s" }}
                  onMouseOver={(e) => { e.target.style.color = "#3b82f6"; e.target.style.transform = "translateY(-1px)"; }}
                  onMouseOut={(e) => { e.target.style.color = "#1e293b"; e.target.style.transform = "translateY(0)"; }}
                >
                  <i className="bi bi-person-workspace me-2"></i> TASK TRACKER
                </a>
              </li>
              {/*
              <li className="nav-item" style={{ marginLeft: "10px" }}>
                <a
                  className="nav-link active"
                  aria-current="page"
                  href="/worker-salary-view"
                  style={{ fontWeight: "600", color: "#1e293b", fontSize: "14px", letterSpacing: "0.5px", padding: "8px 16px", borderRadius: "8px", transition: "all 0.2s" }}
                  onMouseOver={(e) => { e.target.style.color = "#16a34a"; e.target.style.transform = "translateY(-1px)"; }}
                  onMouseOut={(e) => { e.target.style.color = "#1e293b"; e.target.style.transform = "translateY(0)"; }}
                >
                  <i className="bi bi-wallet2 me-2"></i> MY SALARY
                </a>
              </li>
              */}
            </ul>
            
            <div className="d-flex align-items-center">
              <span style={{ marginRight: "10px", fontWeight: "500", color: "#1e293b" }}>Welcome, {user?.Name}! </span>
              <div className="dropdown">
                <a
                  className="d-flex align-items-center text-decoration-none dropdown-toggle"
                  role="button"
                  id="dropdownMenuLink"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  style={{ marginRight: "20px", marginLeft: "10px" }}
                >
                  <img
                    src={UserImg}
                    alt="Profile"
                    className="rounded-circle"
                    style={{ width: "40px", height: "40px", objectFit: "cover" }}
                  />
                </a>
                <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuLink">
                  <li>
                    <a className="dropdown-item text-danger" onClick={logout} style={{ cursor: 'pointer' }}>
                      Logout
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </nav>

      {/* Main Content */}
      <div className="container mt-4 mb-5" style={{ maxWidth: '1200px' }}>
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-4 gap-3">
          <div>
            <h3 className="fw-bold text-dark mb-1">My Salary Dashboard</h3>
            <p className="text-muted mb-0">View your monthly earnings and payout history.</p>
          </div>
          <button className="btn btn-outline-secondary rounded-pill px-4 shadow-sm bg-white" onClick={() => window.location.href = '/User-dashboard'} style={{ fontWeight: '600' }}>
            <i className="bi bi-arrow-left me-2"></i>Back to Dashboard
          </button>
        </div>

        {/* Filter Section */}
        <div className="card shadow-sm border-0 rounded-4 mb-4">
          <div className="card-body p-4 d-flex flex-column flex-md-row justify-content-between align-items-center gap-3" style={{ background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)' }}>
            <div className="d-flex align-items-center gap-2">
              <div className="bg-primary bg-opacity-10 p-2 rounded-circle">
                <i className="bi bi-calendar-check text-primary fs-4"></i>
              </div>
              <h5 className="mb-0 fw-bold ms-2 text-dark">Select Month & Year</h5>
            </div>
            <div className="d-flex gap-3 align-items-center bg-white border p-2 rounded-pill shadow-sm">
              <div className="d-flex align-items-center px-2 gap-2">
                <i className="bi bi-calendar3 text-secondary me-1"></i>
                <select 
                  className="form-select form-select-sm border-0 shadow-none fw-bold text-dark" 
                  value={selectedMonth} 
                  onChange={e => setSelectedMonth(Number(e.target.value))}
                  style={{ minWidth: '110px', cursor: 'pointer', backgroundColor: 'transparent' }}
                >
                  {[...Array(12)].map((_, i) => (
                    <option key={i+1} value={i+1}>
                      {new Date(0, i).toLocaleString('default', { month: 'long' })}
                    </option>
                  ))}
                </select>
                <div className="vr text-secondary"></div>
                <select 
                  className="form-select form-select-sm border-0 shadow-none fw-bold text-dark" 
                  value={selectedYear} 
                  onChange={e => setSelectedYear(Number(e.target.value))}
                  style={{ minWidth: '90px', cursor: 'pointer', backgroundColor: 'transparent' }}
                >
                  {[...Array(5)].map((_, i) => {
                    const yr = new Date().getFullYear() - 2 + i;
                    return <option key={yr} value={yr}>{yr}</option>;
                  })}
                </select>
              </div>
            </div>
          </div>
        </div>

        {/* Selected Month Salary Card */}
        {selectedSalary ? (
          <div className="card shadow border-0 mb-5 rounded-4 overflow-hidden" style={{ transition: 'all 0.3s' }}>
            <div className="card-header text-white p-4 bg-primary" style={{ 
              background: 'linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)'
            }}>
              <div className="d-flex justify-content-between align-items-center">
                <h4 className="mb-0 fw-bold">
                  <i className="bi bi-wallet2 me-2"></i>
                  {new Date(0, selectedMonth - 1).toLocaleString('default', { month: 'long' })} {selectedYear} Salary Summary
                </h4>
                <span className="badge bg-white text-dark rounded-pill px-3 py-2 fs-6 shadow-sm">
                  {selectedSalary.PaymentStatus === 'Paid' ? 'Paid' : 'Pending'}
                </span>
              </div>
            </div>
            <div className="card-body p-4 bg-white">
              <div className="row text-center align-items-center">
                <div className="col-6 col-md-2 mb-4 mb-md-0">
                  <div className="p-3 bg-light rounded-4 h-100 d-flex flex-column justify-content-center">
                    <p className="text-muted mb-2 small text-uppercase fw-bold letter-spacing-1">Total Earned</p>
                    <h5 className="text-dark fw-bold mb-0">₹{parseFloat(selectedSalary.TotalEarned).toFixed(2)}</h5>
                  </div>
                </div>
                <div className="col-6 col-md-2 mb-4 mb-md-0">
                  <div className="p-3 bg-light rounded-4 h-100 d-flex flex-column justify-content-center">
                    <p className="text-muted mb-2 small text-uppercase fw-bold letter-spacing-1">Present</p>
                    <h5 className="text-primary fw-bold mb-0"><i className="bi bi-calendar-check me-1"></i>{selectedSalary.PresentDays}</h5>
                  </div>
                </div>
                <div className="col-6 col-md-2 mb-4 mb-md-0">
                  <div className="p-3 bg-danger bg-opacity-10 rounded-4 h-100 d-flex flex-column justify-content-center">
                    <p className="text-danger mb-2 small text-uppercase fw-bold letter-spacing-1">Advances</p>
                    <h5 className="text-danger fw-bold mb-0">-₹{parseFloat(selectedSalary.AdvancesDeducted).toFixed(2)}</h5>
                  </div>
                </div>
                <div className="col-6 col-md-2 mb-4 mb-md-0">
                  <div className="p-3 bg-danger bg-opacity-10 rounded-4 h-100 d-flex flex-column justify-content-center">
                    <p className="text-danger mb-2 small text-uppercase fw-bold letter-spacing-1">Penalties</p>
                    <h5 className="text-danger fw-bold mb-0">-₹{parseFloat(selectedSalary.Penalties).toFixed(2)}</h5>
                  </div>
                </div>
                <div className="col-12 col-md-4 mt-3 mt-md-0" style={{ display: 'none' }}>
                  <div className="p-4 rounded-4 h-100 d-flex flex-column justify-content-center shadow-sm" style={{ background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)', border: '1px solid #e2e8f0' }}>
                    <p className="text-muted mb-2 text-uppercase fw-bold letter-spacing-1">Net Payable Amount</p>
                    <h2 className="text-success fw-bold mb-0" style={{ fontSize: '2.5rem' }}>₹{parseFloat(selectedSalary.NetPayable).toFixed(2)}</h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="card shadow-sm border-0 mb-5 rounded-4 text-center py-5 bg-white">
            <div className="card-body">
              <div className="display-1 text-muted mb-3 opacity-25">
                <i className="bi bi-wallet2"></i>
              </div>
              <h4 className="text-dark fw-bold">No Salary Finalized</h4>
              <p className="text-muted">Your salary for {new Date(0, selectedMonth - 1).toLocaleString('default', { month: 'long' })} {selectedYear} has not been finalized yet.</p>
            </div>
          </div>
        )}

        <div className="card shadow-sm border-0 rounded-4 overflow-hidden bg-white mb-5">
          <div className="card-header bg-white border-bottom p-4"><h5 className="mb-0 fw-bold text-dark"><i className="bi bi-cash-stack me-2 text-danger"></i>Advance Payment History</h5></div>
          <div className="card-body p-0">
            {advanceHistory.length ? advanceHistory.map(a => <div key={a.RequestId} className="d-flex justify-content-between align-items-center px-4 py-3 border-bottom"><div><strong>Advance payment</strong><div className="small text-muted">{a.PaymentDate ? new Date(a.PaymentDate).toLocaleDateString('en-IN') : 'Payment date unavailable'}</div></div><strong className="text-danger">-₹{parseFloat(a.PaidAmount || 0).toFixed(2)}</strong></div>) : <div className="p-4 text-muted">No paid advances for this selected month.</div>}
          </div>
        </div>

        {/* History Table */}
        <div className="card shadow-sm border-0 rounded-4 overflow-hidden bg-white">
          <div className="card-header bg-white border-bottom p-4 d-flex justify-content-between align-items-center">
            <h5 className="mb-0 fw-bold text-dark"><i className="bi bi-clock-history me-2 text-primary"></i>Salary History</h5>
            <div className="d-flex align-items-center gap-2">
              <span className="text-muted small fw-bold">Filter Year:</span>
              <select 
                className="form-select form-select-sm border" 
                value={tableYearFilter} 
                onChange={e => setTableYearFilter(e.target.value)}
                style={{ width: '90px', cursor: 'pointer' }}
              >
                <option value="All">All</option>
                {[...Array(5)].map((_, i) => {
                  const yr = new Date().getFullYear() - 2 + i;
                  return <option key={yr} value={yr}>{yr}</option>;
                })}
              </select>
            </div>
          </div>
          <div className="card-body p-0">
            <DataTable
              columns={columns.filter(column => !['Net Payable', 'Salary payment'].includes(column.name))}
              data={salaryHistory.filter(s => {
                // Table should only be filtered by its own "Filter Year" dropdown, not the top dropdown
                const matchesYearFilter = tableYearFilter === 'All' || parseInt(s.Year) === parseInt(tableYearFilter);
                return matchesYearFilter;
              })}
              progressPending={loading}
              progressComponent={
                <div className="d-flex flex-column justify-content-center align-items-center py-5 my-3">
                  <div className="spinner-border text-primary mb-3" role="status" style={{ width: '2.5rem', height: '2.5rem' }}></div>
                  <h6 className="text-secondary fw-bold">Loading History...</h6>
                </div>
              }
              pagination
              highlightOnHover
              responsive
              noDataComponent={
                <div className="text-center py-5">
                  <i className="bi bi-inbox fs-1 text-muted opacity-50 mb-3 d-block"></i>
                  <h6 className="text-secondary">No history found</h6>
                </div>
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
}
